import { Link } from 'react-router-dom'
import {
  getItemLink,
  getItemIcon,
} from '../../../components/CategoryGrid/utils'
import noFavorite from '../../../assets/images/noFavorite.png'
import favorite from '../../../assets/images/yesFavorite.png'

interface Card {
  card_id: number
  title: string
  icon_url: string
}

interface FavoriteCardProps {
  card: Card
  onToggleFavorite: (id: string) => void
  isFavorite: boolean
  searchQuery: string
  hasActiveSubscription: () => boolean
}

const FavoriteCard = ({
  card,
  onToggleFavorite,
  isFavorite,
  searchQuery,
  hasActiveSubscription,
}: FavoriteCardProps) => {
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const target = e.target as HTMLImageElement
    target.style.display = 'none'
    target.nextElementSibling?.classList.remove('hidden')
  }

  const handleFavoriteClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    onToggleFavorite(card.card_id.toString())
  }

  // Функция для выделения совпадений в тексте
  const highlightText = (text: string, query: string) => {
    if (!query.trim()) return text

    const regex = new RegExp(
      `(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`,
      'gi'
    )
    const parts = text.split(regex)

    return parts.map((part, index) => {
      if (part.toLowerCase() === query.toLowerCase()) {
        return (
          <mark key={index} className="search-highlight">
            {part}
          </mark>
        )
      }
      return part
    })
  }

  return (
    <Link
      to={getItemLink(card, 'cards')}
      className="category-card favorite-card"
    >
      <img
        src={getItemIcon(card)}
        alt={card.title}
        onError={handleImageError}
        className="category-image"
      />
      <div className="category-info">
        <h3 className="category-name">
          {highlightText(card.title, searchQuery)}
        </h3>
      </div>
      {hasActiveSubscription() && (
        <button
          className={`favorite-button ${isFavorite ? 'favorite-active' : ''}`}
          onClick={handleFavoriteClick}
          title={isFavorite ? 'Удалить из избранного' : 'Добавить в избранное'}
        >
          {isFavorite ? (
            <img src={favorite} alt="favorite" className="favorite-icon" />
          ) : (
            <img src={noFavorite} alt="noFavorite" className="favorite-icon" />
          )}
        </button>
      )}
    </Link>
  )
}

export default FavoriteCard
